export default __webpack_public_path__ + "static/media/img11.8569e934.svg";